import { cn } from "@dalmatech/ui"

const root = cn("max-w-[36.750rem] mx-auto flex flex-col gap-6 lg:gap-8")
const form = cn("flex flex-col gap-6 lg:gap-8")

export { form, root }
